export const STANDARD_SCORE_MEAN = 100;
export const STANDARD_SCORE_SD = 15;

export const STANDARD_SCORE_AXIS_MIN = 40;
export const STANDARD_SCORE_AXIS_MAX = 160;

export const HIGH_BAND_MAX_INDEX = 84.4;
export const MODERATE_BAND_MAX_INDEX = 94.15;

export const HIGH_BAND_DISPLAY_INDEX = 84;
export const MODERATE_BAND_DISPLAY_INDEX = 94;

export function legacyIndexToStandardScore(value: number): number {
  return 25 + value * 1.5;
}

export const OVERALL_SCORE_DISTRIBUTION_INFO =
  "Performance band cutoffs are provisionally calibrated against the current ENSSA year-level reference distribution.";

/** First line of the standard scale-info tooltip (mean + SD). Paired
    with `OVERALL_SCORE_DISTRIBUTION_INFO` (band cut-off note) in the
    two-line tooltip used on chart titles across class/school/district
    and beside the student-page distribution caption. */
export const OVERALL_SCALE_NOTE =
  "100 = year-level ENSSA average \u00b7 15 points = 1 standard deviation";
